import styles from "./MediaInquiry.module.scss";
import React, { useState } from "react";
import Markdown from "components/Markdown/Markdown";
import Button from "components/core/Button/Button";
import Modal from "components/Modal/Modal";
import { useFetchUser } from "source/hooks";
import ContactForm from "components/ContactForm/ContactForm";

type Props = {
  description?: string;
  imageUrl?: string;
};

const MediaInquiry = (props: Props) => {
  const [contactFormIsVisible, setContactFormIsVisible] = useState(false);
  const userBundle = useFetchUser();

  return (
    <div
      className={styles.container}
      style={{
        background: `linear-gradient(0deg, rgba(9, 28, 55, 0.85), rgba(9, 28, 55, 0.85)), url(${props.imageUrl}), #091C37`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: "rgba(9, 28, 55, 0.85)",
      }}
    >
      {props.description ? (
        <Markdown markdownText={props.description} className={styles.title} />
      ) : (
        <h2 className={styles.title}>
          Have a media <span>inquiry?</span>
        </h2>
      )}
      <Button
        arrow
        className={styles.button}
        onClick={() => setContactFormIsVisible(true)}
      >
        Contact Us
      </Button>
      <Modal
        visible={contactFormIsVisible}
        width={522}
        onClose={() => setContactFormIsVisible(false)}
        className={styles.contactUsModal}
      >
        <ContactForm
          user={userBundle.user}
          afterSubmit={() => setContactFormIsVisible(false)}
        />
      </Modal>
    </div>
  );
};

export default MediaInquiry;
